import React from 'react'
import {BrowserRouter , Link} from 'react-router-dom'
import { useTranslation } from 'react-i18next';
// import './i18n';

const About = () => {

    const { t, i18n } = useTranslation();

    return (

        <div className="about shadow d-flex mt-5 pt-5 justify-content-center container">
            
            <div class="container m-auto">
                <div class="row text-center">
                    <div class="col-md-6 mb-4">
                    <img class="rounded-circle z-depth-4"
                        width="250" height="250"
                        alt="sully" src="./soli2.jpg"
                        data-holder-rendered="true"
                    />
                    </div>
                </div>
            </div>
                        
            <div className="aboutme">
                <h1 className="text-warning border-bottom">{t('about me')}</h1>
                <div className="overflow-auto">
                    {t('about me text')}
                {/* Hi!i'm Soleiman Sadeqi(sully),
                B.S in IT engineer,experienced full stack development over 7 years and 
                network engineer for 4 years.
                the technologies which i use , are html javascript 
                CSS Bootstrap  DjangoREST  React Laravel Firebase　
                MySQL Clouds  Nodejs php python　and progressive web app which is 
                installable on <strong>ios</strong> and <strong>Android</strong> deviecs (this's my free service).
                For more information please   */}
                    <Link to="/contact"> {t('contact')}</Link>
                </div>
            </div>
            
        </div>
    )
}

export default About
